import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Trustly } from 'static/images/logos/payments/trustly-white.svg';

function TrustlyComponent() {
  return (
    <Root>
      <Trustly />
    </Root>
  );
}

export default TrustlyComponent;

const Root = styled.div``;
